export default "__VITE_ASSET__DZsctAI___"